module.exports = __webpack_public_path__ + "img/barcos.7d877b19.jpg";